function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import { PHASE, PRIORITY, SETTINGS } from '../constants';
import { getAssetUrlsFromId } from '../manifest';
import { hash, displayNameFromId, isNodeEnvironment } from '../utils';
import { createComponentClient } from './components/client';
import { createComponentServer } from './components/server';
import { createDeferred } from './deferred';
import { ClientLoader, Loader, ServerLoader } from './loader';
import { preloadAsset } from './preload';
import { LazyOptions, LazyComponent } from './types';

function lazyProxy(loader, {
  defer = PHASE.PAINT,
  moduleId = '',
  ssr = true
} = {}) {
  const isServer = isNodeEnvironment();
  const dataLazyId = hash(moduleId);
  const LazyInternal = isServer ? createComponentServer({
    dataLazyId,
    defer,
    loader: loader,
    moduleId,
    ssr
  }) : createComponentClient({
    dataLazyId,
    defer,
    deferred: createDeferred(loader),
    moduleId,
    ssr
  });
  LazyInternal.displayName = `Lazy(${displayNameFromId(moduleId)})`;
  /**
   * Allows getting module chunks urls
   */

  const getAssetUrls = () => {
    return getAssetUrlsFromId(SETTINGS.MANIFEST, moduleId);
  };
  /**
   * Allows imperatively preload/ prefetch the module chunk asset
   */


  const preload = priority => {
    const p = priority != null ? priority : defer === PHASE.PAINT ? PRIORITY.HIGH : PRIORITY.LOW;
    preloadAsset(loader, {
      moduleId,
      priority: p
    });
  };

  return Object.assign(LazyInternal, {
    getAssetUrls,
    preload
  });
}

export const DEFAULT_OPTIONS = {
  lazyForPaint: {
    ssr: true,
    defer: PHASE.PAINT
  },
  lazyAfterPaint: {
    ssr: true,
    defer: PHASE.AFTER_PAINT
  },
  lazy: {
    ssr: false,
    defer: PHASE.LAZY
  }
};
export function lazyForPaint(loader, opts) {
  return lazyProxy(loader, _extends(_extends({}, DEFAULT_OPTIONS.lazyForPaint), opts || {}));
}
export function lazyAfterPaint(loader, opts) {
  return lazyProxy(loader, _extends(_extends({}, DEFAULT_OPTIONS.lazyAfterPaint), opts || {}));
}
export function lazy(loader, opts) {
  return lazyProxy(loader, _extends(_extends({}, DEFAULT_OPTIONS.lazy), opts || {}));
}
export { LoaderError, isLoaderError } from './errors/loader-error';